import { sendRequest, ppAxios, ppAxiosInstance } from '../config'

/**
 * 支付链-查询菜单是否显示
 */
export const paymentLinkPermission = () => {
	return sendRequest(['GET', '/merchant/payLink/hasPermission'], {})
}

/**
 * 支付链-查询列表数据
 */
export const payLinkList = param => {
	return sendRequest(['POST', '/merchant/payLink/list'], param)
}

/**
 * 支付链-新增支付链
 */
export const addPayLink = param => {
	return sendRequest(['POST', '/merchant/payLink/add'], param)
}

/**
 * 支付链-查询详情
 */
export const payLinkDetail = id => {
	return sendRequest(['GET', `/merchant/payLink/detail/${id}`])
}

/**
 * 支付链-再次发送邮件提醒
 */
export const reSendEmail = id => {
	return sendRequest(['GET', `/merchant/payLink/reSendEmail/${id}`])
}

/**
 * 支付链-失效支付链
 */
export const invalidate = id => {
	return sendRequest(['GET', `/merchant/payLink/invalidate/${id}`])
}

/**
 * 支付链-导出支付链记录
 */
export const exportExcel = (param) => {
	return ppAxios(['POST', '/merchant/payLink/exportExcel'], param, { responseType: 'blob' })
}

/**
 * 支付链-订单确认-跳转
 */
export const toOrderConfirm = token => {
	return sendRequest(['GET', `/merchant/payLink/toOrderConfirm/${token}`])
}

/**
 * 支付链-订单确认-国家码
 */
export const countryInfo = () => {
	return sendRequest(['GET', '/merchant/payLink/countryInfo'])
}

/**
 * 品牌列表分页查询
 */
export const payBrandList = (params) => {
	return sendRequest(['POST', '/merchant/payBrand/queryPage'], params)
}

/**
 *
 * 品牌删除
 */
export const payBrandDelete = (params) => {
	return sendRequest(['POST', '/merchant/payBrand/delete'], params)
}

/**
 * 品牌增加
 */
export const payBrandAdd = (params) => {
	return sendRequest(['POST', '/merchant/payBrand/add'], params)
}

/**
 * 品牌修改
 */
export const payBrandModify = (params) => {
	return sendRequest(['POST', '/merchant/payBrand/modify'], params)
}

/**
 * 品牌列表枚举
 */
export const getBrandList = (params) => {
	return sendRequest(['POST', '/merchant/payBrand/getBrandList'], params)
}

/**
 * 品牌编辑页面加载
 */
export const queryBrandById = (params) => {
	return sendRequest(['GET', '/merchant/payBrand/queryById'], params)
}

/**
 * 品牌预览
 */
export const previewById = (params) => {
	return sendRequest(['GET', '/merchant/payBrand/previewById'], params)
}

/**
 * 订单确认
 */
export const payLinkOrder = token => {
	return sendRequest(['GET', `/merchant/payLink/orderDetail/${token}`])
}

/**
 * 支付国内银联
 */
export const payInUnionpay = token => {
	return sendRequest(['POST', `/merchant/payLink/${token}/chinamusPay`])
}

/**
 * 获取国家
 */
export const getCountryList = () => {
	return sendRequest(['GET', '/merchant/payLink/countryInfo'])
}

/**
 * checkout
 */
export const checkoutBill = (token, params = {}) => {
	return sendRequest(['POST', `/merchant/payLink/orderConfirmCheckout/${token}`], params)
}

/**
 * 查询系统邮箱下拉框
 */
export const getEmailSenderList = () => {
	return sendRequest(['GET', '/merchant/payBrand/getEmailSenderList'])
}

/**
 * 春秋航空定制 - 获取商户基本信息
 */
export const getMerchantInfo = (params) => {
	return sendRequest(['POST', '/merchant/payLink/getMerchantInfo'], params, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}

/**
 * 春秋航空定制 - 新增支付链
 */
export const addPayLinkOnline = (params) => {
	return sendRequest(['POST', '/merchant/payLink/addPayLinkOnline'], params)
}

/**
 * 支付链行业枚举
 */
export const payLinkIndustry = () => {
	return sendRequest(['POST', '/merchant/newPayLink/template/industry'])
}

/**
 * 支付链模版字段配置
 */
export const getTemplateConfig = (params) => {
	return sendRequest(['POST', '/merchant/newPayLink/template/config'], params)
}

/**
 * 支付链模版列表 - 查询
 */
export const getTemplateList = (params) => {
	return sendRequest(['POST', '/merchant/newPayLink/template/list'], params)
}

/**
 * 支付链 模版列表 - 删除
 */
export const templateDelete = (id) => {
	return sendRequest(['GET', `/merchant/newPayLink/template/delete/${id}`])
}

/**
 * 支付链 模版 - 详情
 */
export const queryTemplateById = (id) => {
	return sendRequest(['GET', `/merchant/newPayLink/template/detail/${id}`])
}

/**
 * 支付链 模版 - 新增
 */
export const templateAdd = (params) => {
	return ppAxiosInstance.post('/merchant/newPayLink/template/add', params)
}

/**
 * 支付链模版详情 - 编辑
 */
export const templateModify = (params) => {
	return ppAxiosInstance.post('/merchant/newPayLink/template/update', params)
}

/**
 * 支付链-新增支付链V2
 */
export const addPayLinkV2 = params => {
	return sendRequest(['POST', '/merchant/payLink/v2/add'], params)
}

/**
 * 支付链v3 - 模式查询
 */
export const queryPayLinkModePage = params => {
	return sendRequest(['POST', '/merchant/payLink/queryPayLinkModePage'], params)
}

/**
 * 支付链v3 - 主题查询
 */
export const queryPayLinkSubjectList = params => {
	return sendRequest(['POST', '/merchant/payLink/queryPayLinkSubjectList'], params)
}

/**
 * 支付链v3 - 模式新增/编辑
 */
export const addOrUpdateMode = params => {
	return sendRequest(['POST', '/merchant/payLink/addOrUpdateMode'], params)
}

/**
 * 支付链v3 - 主题新增/编辑
 */
export const addOrUpdateSubject = params => {
	return sendRequest(['POST', '/merchant/payLink/addOrUpdateSubject'], params)
}

/**
 * 支付链v3 - 模式详情
 */
export const queryPayLinkModeDetail = params => {
	return sendRequest(['POST', '/merchant/payLink/queryPayLinkModeDetail'], params)
}

/**
 * 支付链v3 - 模式 - 邮件预览
 */
export const emailPreview = params => {
	return sendRequest(['POST', '/merchant/payLink/emailPreview'], params)
}

/**
 * 支付链v3 - 主题详情
 */
export const queryPayLinkSubjectDetail = params => {
	return sendRequest(['POST', '/merchant/payLink/queryPayLinkSubjectDetail'], params)
}

/**
 * 支付链v3 - 删除模式
 */
export const removePayLinkMode = params => {
	return sendRequest(['POST', '/merchant/payLink/removePayLinkMode'], params)
}

/**
 * 支付链v3 - 删除主题
 */
export const removePayLinkSubject = params => {
	return sendRequest(['POST', '/merchant/payLink/removePayLinkSubject'], params)
}

/**
 * 支付链v3 - 更新默认主题
 */
export const updateDefaultSubject = params => {
	return sendRequest(['POST', '/merchant/payLink/updateDefaultSubject'], params)
}

/**
 * 支付链v3 - 获取模式、主题列表集合
 */
export const queryPayLinkModeSubject = params => {
	return sendRequest(['POST', '/merchant/payLink/queryPayLinkModeSubject'], params)
}

/**
 * 支付链v3 - 账单预览
 */
export const billPreview = params => {
	return sendRequest(['POST', '/merchant/payLink/billPreview'], params)
}

/**
 * 支付链-新增支付链V3
 */
export const addPayLinkV3 = params => {
	return sendRequest(['POST', '/merchant/payLink/v3/add'], params)
}
